import "src/decidim/proposals/utils"
import "src/decidim/proposals/add_proposal"
import "src/decidim/proposals/choose_proposals"
import "src/decidim/proposals/exit_handler"

// Images
require.context("../images", true)

// Documents
require.context("../documents", true)

// CSS
import "stylesheets/decidim/proposals/proposals.scss"
